import { Injectable } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { environment } from '../../environments/environment';
import { AuthHeaderService } from '../views/authheader.service';
import { map, catchError } from 'rxjs/operators';
import { throwError as observableThrowError, Observable, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class JobdashboardService {

  public changeComapany = new Subject<any>();
  changeObservable$ = this.changeComapany.asObservable();

  joburl: string;
  itemurl: string;
  writeoffurl: string
  constructor(private http: Http, private _headerService: AuthHeaderService) {
    this.joburl = environment.joburl + "/jobdashboard";
  }

  //rokib section started
  getJobUpcomingDeadlineData(filterOptions?: any) {
    let url = this.joburl + "/jobdeadlineschedule?";
    url = url + "jobStatus=" + filterOptions.jobStatus;
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getJobSales() {
    let url = this.joburl + "/jobsales";
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getJobSpend() {
    let url = this.joburl + "/jobspend";
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  // getJobWorkHourTimeLineData() {
  //   let url = environment.joburl + "/jobdashboard/workhour";
  //   let options = new RequestOptions({
  //     headers: this._headerService.getHeader(),
  //   });
  //   return this.http.get(url, options).pipe(
  //     map((response) => (response.json().data ? [] : response.json())),
  //     catchError((error: Response) => {
  //       return observableThrowError(error);
  //     })
  //   );
  // }

  getJobWorkHourTimeLineData() {
    let url = environment.joburl + "/jobdashboard/workhour";
    console.log("Request URL:", url); // Log the URL being requested
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => {
        console.log("Response:", response); // Log the response
        return response.json().data ? [] : response.json();
      }),
      catchError((error: Response) => {
        console.error("Error:", error); // Log the error
        return observableThrowError(error);
      })
    );
  }


  //rokib section ended


  //shihab section started
  getJobOverviewData(filterOptions?: any) {
    let url = this.joburl + "/joboverview";

    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getJobProfitability(filterOptions?: any) {
    let url = this.joburl + "/jobprofitability";

    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  //shihab section ended
  //manik section started
  getPendingJobSummary(filterOptions?: any) {
    let url = this.joburl + "/pendingjobsummary";

    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getTopJobs(filterOptions?: any) {
    let url = this.joburl + "/topjobs";

    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getDriverCarrierTimelineData(query?: any) {
    let url = this.joburl + "/drivercarrierworktimeline" + "?";
    if (query?.fromDate) {
      url = url + "fromDate=" + query.fromDate + '&';
    }
    if (query?.toDate) {
      url = url + "toDate=" + query.toDate + '&';
    }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url , options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  //manik section ended
















}

// function observableThrowError(error: Response): any {
//   throw new Error('Function not implemented.');
// }

